/* 
  故障工单 
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>故障记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 状态 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="tabs_style">
      <el-tab-pane label="未处理故障" name="first">
        <!-- 查询 -->
        <el-form :inline="true" :model="formInline">
          <el-form-item label="车辆编号:">
            <el-input size="small" v-model="formInline.vin" placeholder="输入车辆编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="故障详情:">
            <el-input size="small" v-model="formInline.faultDetails" placeholder="输入故障详情" clearable></el-input>
          </el-form-item>
          <el-form-item label="车辆类型:">
            <el-input size="small" v-model="formInline.carType" placeholder="输入车辆类型" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table size="small" :data="tableData" highlight-current-row border style="width: 100%">
          <el-table-column align="center" prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column align="center" prop="vin" min-width="200" label="车辆编号">
            <template slot-scope="scope">
              <div @click="ondblclick(scope.row)">{{ scope.row.vin }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="equipment_name" min-width="150" label="故障系统">
          </el-table-column>
          <el-table-column align="center" prop="fault_details" min-width="300" label="故障详情">
          </el-table-column>
          <el-table-column align="center" prop="car_type" min-width="120" label="车辆类型">
          </el-table-column>
          <el-table-column align="center" prop="fault_time_str" min-width="200" label="故障时间">
          </el-table-column>
          <el-table-column align="center" prop="pc_status" min-width="120" label="故障状态">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.pc_status == '已处理' ? 'success' : 'info'">
                {{ scope.row.pc_status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="pc_note" min-width="300" label="故障描述">
          </el-table-column>
          <el-table-column align="center" label="操作" width="150" v-if="check_auth('/web/fault_record_handle')">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" icon="el-icon-edit" round @click="handleEdit(scope.row)"
                v-if="check_auth('/web/fault_record_handle')">处理
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="已处理故障" name="second">
        <!-- 查询 -->
        <el-form :inline="true" :model="successFormInline">
          <el-form-item label="车辆编号:">
            <el-input size="small" v-model="successFormInline.vin" placeholder="输入车辆编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="故障详情:">
            <el-input size="small" v-model="successFormInline.faultDetails" placeholder="输入故障详情" clearable></el-input>
          </el-form-item>
          <el-form-item label="车辆类型:">
            <el-input size="small" v-model="formInline.carType" placeholder="输入车辆类型" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="searchSuccess">搜索</el-button>
          </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
          <el-table-column align="center" prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column align="center" prop="vin" min-width="200" label="车辆编号">
            <template slot-scope="scope">
              <div @click="ondblclick(scope.row)" v-if="check_auth('/web/carMonitor/detail')">{{ scope.row.vin }}</div>
              <div v-else>{{ scope.row.vin }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="equipment_name" min-width="150" label="故障系统">
          </el-table-column>
          <el-table-column align="center" prop="fault_details" min-width="300" label="故障详情">
          </el-table-column>
          <el-table-column align="center" prop="car_type" min-width="120" label="车辆类型">
          </el-table-column>
          <el-table-column align="center" prop="fault_time_str" min-width="200" label="故障时间">
          </el-table-column>
          <el-table-column align="center" prop="pc_status" min-width="120" label="故障状态">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.pc_status == '已处理' ? 'success' : 'info'">
                {{ scope.row.pc_status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="pc_note" min-width="300" label="故障描述">
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="margin-top: 10px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="page_parm.currentPage" background :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page_parm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page_parm.total">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 编辑巡检结果 -->
    <el-dialog title="处理故障" :visible.sync="editFrom" width="35%" :close-on-click-modal="false">
      <el-form :model="editFromList">
        <el-form-item label="故障描述" label-width="80px">
          <el-input type="textarea" v-model="editFromList.outcome"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="mini" type="primary" @click="submitEdit">确 定</el-button>
        <el-button size="mini" @click="editFrom = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import {
  get_fault_record_list,
  get_fault_record_handle
} from "../../api/faultOrder_mn/faultOrder";
import {
  auth
} from "../../utils/util";
export default {
  data() {
    return {
      editFrom: false,
      input: "",
      activeName: "first",
      tableData: [],
      listData: [],
      formInline: {
        vin: "",
        faultDetails: "",
        carType: "",
        faultStatus: 0,
        page: 1,
        limit: 10,
      },
      successFormInline: {
        vin: "",
        faultDetails: "",
        carType: "",
        faultStatus: 1,
        page: 1,
        limit: 10,
      },
      editFromList: {
        id: "",
        outcome: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      page_parm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.activeName = 'first';
    window.localStorage.removeItem("fault_vin");
    this.getdata();
  },
  methods: {
    check_auth(val) {
      return auth(val);
    },
    //待处理列表
    getdata() {
      get_fault_record_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.tableData = res.data;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].pc_status = this.tableData[i].pc_status === 0 ? "未处理" : "已处理"
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.total;
        }
      })
    },
    getSuccessdata() {
      window.localStorage.removeItem("fault_vin");
      get_fault_record_list(this.successFormInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data;
          for (let i = 0; i < this.listData.length; i++) {
            this.listData[i].pc_status = this.listData[i].pc_status === 0 ? "未处理" : "已处理"
          }
          this.page_parm.currentPage = this.successFormInline.page;
          this.page_parm.pageSize = this.successFormInline.limit;
          this.page_parm.total = res.total;
        }
      })
    },
    ondblclick(row) {
      window.localStorage.setItem("fault_vin", row.vin);
      this.$router.push("/worksheet_mn/faultStatistics");
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    searchSuccess() {
      this.successFormInline.page = 1;
      this.getSuccessdata();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    fautoderFather() {
      this.successFormInline.page = this.page_parm.currentPage;
      this.successFormInline.limit = this.page_parm.pageSize;
      // this.getSuccessdata();
    },
    handleClick() {
      if (this.activeName == 'first') {
        this.getdata();
        this.formInline.page = 1;
      } else {
        this.getSuccessdata();
        this.successFormInline.page = 1;
      }
    },
    //编辑页面
    handleEdit(row) {
      this.editFrom = true;
      this.editFromList.id = row.id;
    },
    //编辑提交方法
    submitEdit() {
      this.editFrom = false;
      get_fault_record_handle(this.editFromList).then((res) => {
        if (res["code"] === 0) {
          this.$message.success(res["message"]);
          this.getdata()
        }
      })
    },
    handleSizeChange(val) {
      this.page_parm.pageSize = val;
      this.fautoderFather();
    },
    handleCurrentChange(val) {
      this.page_parm.currentPage = val;
      this.fautoderFather();
    },
  },
};
</script>

<style>
.tabs_style {
  margin-top: 30px;
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/worksheet_mn/FaultOrder_mn.vue